import { InjectionToken } from '@angular/core';
import { OperatorTypeEnum } from '@y42/json-schema';

export const DEFAULT_OPERATOR_TYPE = new InjectionToken<OperatorTypeEnum | undefined>('Default date operator type');
